import { format } from 'date-fns';
import { formatInTimeZone as tzFormatInTimeZone } from 'date-fns-tz';
import { DateFormats } from './formats';
import { DateInput, DateInputFormat, FormatOptions } from './types';
import { parseISO } from './parse';

export const formatDate = (
  date?: DateInput,
  dateFormat: DateInputFormat = DateFormats.MonthDayYearSlashDisplay,
  options: FormatOptions = {},
): string => {
  let dateRef = date || new Date();

  if (typeof dateRef === 'string') {
    dateRef = parseISO(date as string);
  }

  return format(dateRef, dateFormat, options);
};

export const formatMonthDayYearTimeDisplay = (
  date?: DateInput,
  options?: FormatOptions,
) => formatDate(date, DateFormats.MonthDayYearSlashTimeDisplay, options);

export const formatDayOfMonthOrdinal = (
  date?: DateInput,
  options?: FormatOptions,
) => formatDate(date, DateFormats.DayOfMonthOrdinal, options);

export const formatMonthDayYearSlashShortYear = (
  date?: DateInput,
  options?: FormatOptions,
) => formatDate(date, DateFormats.MonthDayYearSlashShortYear, options);

export const formatToCalendarDate = (date?: string) => (date ? formatDate(date) : '');

export const formatInTimeZone = (
  date?: DateInput,
  dateFormat: DateInputFormat = DateFormats.MonthDayYearSlashDisplay,
  timezone: string = 'UTC',
  options: FormatOptions = {},
) => {
  let dateRef = date || new Date();

  if (typeof dateRef === 'string') {
    dateRef = parseISO(date as string);
  }

  return tzFormatInTimeZone(dateRef, timezone, dateFormat, options);
};

export const formatToOrdinalString = (day: string) => formatDate(
  new Date(
    2025,
    0,
    Number(day),
  ),
  DateFormats.DayOfMonthOrdinal,
);
